import { Injectable } from "@angular/core";
import { PostServiceM3 } from "../../ConexionSQL/posts.service";

@Injectable({
  providedIn: 'root'
})
export class M3NotifService {
  constructor(private oPostServiceM3: PostServiceM3) {
  }

  /**
   * Obtener la informacion de las notidicaciones por hub
   * @param sIDKatios Empresa
   */
  public async M3GetM3NotificacionesXHubObject(sIDKatios: string, oDataSend: any) {
    try {
      var resp = await this.oPostServiceM3.getWithBodyM3("M3NotifController/M3GetM3NotificacionesXHubObject/" + sIDKatios, oDataSend).toPromise();
      return resp;
    }
    catch{
      return null;
    }
  }


  /**
   * Obtener la informacion de las notidicaciones por hub
   * @param sIDKatios Empresa
   */
  public async M3GetM3NotificacionesXHubObjectWithTimeOut(sIDKatios: string, oDataSend: any, timeOut: number) {
    try {
      var resp = await this.oPostServiceM3.getWithBodyM3TimeOut("M3NotifController/M3GetM3NotificacionesXHubObject/" + sIDKatios, oDataSend, timeOut).toPromise();
      return resp;
    }
    catch{
      return null;
    }
  }

  /**
   * Obtener la informacion de las notidicaciones por hub de un idRep dado
   * @param sIDKatios 
   * @param data 
   */
  public async m3_get_notificacion_x_hub_object(sIDKatios: string, data: any) {
    //var data = {"id_rep":"", "id_ubicacion":"", "id_hub":""}
    try {
      var resp = await this.oPostServiceM3.getWithBodyM3("M3NotifController/m3_get_notificacion_x_hub_object/" + sIDKatios, data).toPromise();
      var data = JSON.parse(JSON.stringify(resp));
      return data;
    }
    catch{
      return null;
    }
  }

  guardarCambiosConfiguracionImpresion(PostServiceM3: PostServiceM3, sIDKatios: string, data: any, oFuncionOK: Function, oFuncionErr: Function) {

    PostServiceM3.postServiceHttpResFullM3("M3NotifController/guardarCambiosConfiguracionImpresion/" + sIDKatios.trim(), data).subscribe(resp => {
      oFuncionOK();
    },
      error => {
        oFuncionErr(error["_body"]);
      });
  }

}